import styled from 'styled-components/native';

export const InputContainer = styled.View`
  flex: 1;
  flex-direction: column;
  padding: 20px;
  background-color: #F7F9FB;
  align-items: center;
`